import { Routes } from '@angular/router';

import { LoginComponent } from './authentication/login/login.component';
import { HomeComponent } from './pages/home/home.component';
import { RegisterComponent } from './authentication/register/register.component';
// import { NotFoundComponent } from './authentication/notfound/not-found.component';
import { ErrorPageComponent } from './component/error-page/error-page.component';


export const APP_ROUTES: Routes = [
  //{ path: '', component: LoginComponent },
  //{ path: 'login/:opcion', component: LoginComponent },
  //{ path: 'registro', component: RegisterComponent},
  { path: '', component: LoginComponent },
  { path: 'login/:opcion', component: LoginComponent },
  { path: 'registro', component: RegisterComponent},
  { path: 'error-page', component: ErrorPageComponent },
  // { path: '**', redirectTo: 'error-page' }, // Optional: Redirect unknown routes to the error page
  {
    path: '',
    component: HomeComponent,
    children: [
        { path: 'dashboard', loadChildren: () => import('./dashboards/dashboard.module').then(m => m.DashboardModule) },
        // { path: 'catalogos', loadChildren: () => import('./pages/catalogos/catalogo.module').then(m => m.CatalogoModule) },
        // { path: 'administracion', loadChildren: () => import('./pages/administracion/administracion.module').then(m => m.AdministracionModule) },
        { path: 'administracion', loadChildren: () => import('./pages/administracion/administracion.module').then(m => m.AdministracionModule) },
        { path: '**', redirectTo: 'dashboard/tracer', pathMatch: 'full' }
    ]
  },
  { path: '**', redirectTo: '/dashboard/tracer', pathMatch: 'full'},
];
